var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.179,
    height: 16.179,
    viewBox: "0 0 16.179 16.179",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#208ce1;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12.5 -12.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.5,35.745V39.11h3.365l9.945-9.945L22.445,25.8Z",
    transform: "translate(0 -10.431)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M68.026,16.1a.912.912,0,0,0,0-1.273l-2.092-2.071a.912.912,0,0,0-1.273,0L63,14.4l3.387,3.387Z",
    transform: "translate(-39.606 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueEditIcon);
export default __webpack_public_path__ + "static/media/blue_edit_icon.7f1d18ced0c3713e088657bb59b33d5e.svg";
export { ForwardRef as ReactComponent };